import React from 'react'
import Lottie from 'react-lottie';
import animationData from './welcome.json'


export default class Welcome extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isStopped: false, isPaused: false };
    }


    render() {
        const buttonStyle = {
            display: 'block',
            margin: '10px auto'
        };

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        return <div>
            <Lottie options={defaultOptions}
                height={500}
                width={500}
                isStopped={this.state.isStopped}
                isPaused={this.state.isPaused} />

        </div>
    }
}
